import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";

//import images
import { useRole } from "components/Hooks/UserHooks";
import {
  Card,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import AuditionInfoTab from "pages/ApplicationManagement/Tabs/AuditionInfoTab";
import ApplicantInfoTab from "pages/ApplicationManagement/Tabs/ApplicantInfoTab";
import AuditionStatus from "pages/ApplicationManagement/Tabs/AuditionStatus";
import applicationApi from "api/applicationApi";

export interface Tag {
  id: string;
  text: string;
}

export interface Props {
  isOpen: boolean;
  triggerRefresh?: () => void;
  onClose?: () => void;
}

registerLocale("en", en);
registerLocale("ko", ko);

const UserDetail = ({ isOpen, item, triggerRefresh, onClose }: any) => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();
  const [data, setData] = useState<any>();

  const [activeTab, setActiveTab] = useState("AUDITION_INFO");

  async function getDataDetail() {
    const res = await applicationApi.getDetails(item?.id);
    console.log(res);
    setData(res?.data);
  }

  useEffect(() => {
    getDataDetail();
  }, []);

  const tabChange = (tab: any) => {
    if (activeTab !== tab) {
      setActiveTab((_prev) => tab);
    }
  };

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onCloseClick = () => {
    onClose && onClose();
  };

  return (
    <Modal isOpen={isOpen} centered={true} size="xl" scrollable={true}>
      <ModalHeader toggle={onCloseClick}>{t("Application Detail")}</ModalHeader>
      <ModalBody className="pt-0">
        <div style={{ minHeight: "calc(100dvh - 200px)" }}>
          <Col lg={12}>
            <Card
              id="AUDITION_INFO"
              style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
            >
              <div
                style={{
                  background: "#f3f6f9",
                  borderTopLeftRadius: "0.6rem",
                  borderTopRightRadius: "0.6rem",
                }}
              >
                <div
                  className="d-block"
                  style={{
                    background: "#f3f6f9",
                    borderRadius: "0.6rem",
                    width: "fit-content",
                  }}
                >
                  <Nav
                    tabs
                    className="nav nav-tabs nav-link-none-hover nav-justified"
                  >
                    <NavItem style={{ minWidth: "180px" }}>
                      <NavLink
                        style={{
                          cursor: "pointer",
                          background: `${
                            activeTab === "AUDITION_INFO"
                              ? "var(--vz-primary)"
                              : "unset"
                          }`,
                          color: `${
                            activeTab === "AUDITION_INFO" ? "white" : "unset"
                          }`,
                          borderTopRightRadius: 0,
                        }}
                        onClick={() => tabChange("AUDITION_INFO")}
                      >
                        {t("Audition Info")}
                      </NavLink>
                    </NavItem>
                    <NavItem style={{ minWidth: "180px" }}>
                      <NavLink
                        style={{
                          cursor: "pointer",
                          background: `${
                            activeTab === "APPLICANT_INFO"
                              ? "var(--vz-primary)"
                              : "unset"
                          }`,
                          color: `${
                            activeTab === "APPLICANT_INFO" ? "white" : "unset"
                          }`,
                          borderTopLeftRadius: 0,
                          borderTopRightRadius: 0,
                        }}
                        onClick={() => tabChange("APPLICANT_INFO")}
                      >
                        {t("Applicant Info")}
                      </NavLink>
                    </NavItem>
                    <NavItem style={{ minWidth: "140px" }}>
                      <NavLink
                        style={{
                          cursor: "pointer",
                          background: `${
                            activeTab === "AUDITION_STATUS"
                              ? "var(--vz-primary)"
                              : "unset"
                          }`,
                          color: `${
                            activeTab === "AUDITION_STATUS" ? "white" : "unset"
                          }`,
                          borderTopLeftRadius: 0,
                          borderTopRightRadius: 0,
                        }}
                        onClick={() => tabChange("AUDITION_STATUS")}
                      >
                        {t("Audition Status")}
                      </NavLink>
                    </NavItem>
                  </Nav>
                </div>
              </div>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="AUDITION_INFO">
                  {activeTab === "AUDITION_INFO" && (
                    <AuditionInfoTab activeTab={activeTab} data={data} />
                  )}
                </TabPane>
                <TabPane tabId="APPLICANT_INFO">
                  {activeTab === "APPLICANT_INFO" && (
                    <ApplicantInfoTab activeTab={activeTab} data={data} />
                  )}
                </TabPane>
                <TabPane tabId="AUDITION_STATUS">
                  {activeTab === "AUDITION_STATUS" && (
                    <AuditionStatus activeTab={activeTab} data={data} />
                  )}
                </TabPane>
              </TabContent>
            </Card>
          </Col>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default UserDetail;
